<template>
  <div class="card">
    <div class="card-header">
      <valuation-header
        :refNo="valuation.val_ref_num"
        :valuation="valuation"
        page="Photos"
        @valuationUpdated="valuation = $event"
      ></valuation-header>
    </div>
    <div class="card-body">
      <rv-wizard></rv-wizard>
      <div class="row" style="margin-bottom: 30px">
        <div class="col-md-12">
          <button
            type="button"
            class="btn btn-icon btn-border"
            style="margin-right: 5px"
            @click="markAsPriority"
            :disabled="valuation.isLocked == true"
            title="Toggle Priority"
          >
            <i class="fa fa-space-shuttle" aria-hidden="true"></i>
          </button>

          <button
            type="button"
            class="btn btn-icon btn-border"
            title="Add Photos"
            @click="showAddPhotosModal"
            style="margin-right: 5px"
            :disabled="valuation.isLocked == true"
          >
            <i class="fa fa-camera" aria-hidden="true"></i>
          </button>

          <button
            type="button"
            class="btn btn-icon btn-border"
            title="Bulk upload"
            @click="showBulkAddPhotosModal"
            style="margin-right: 5px"
            :disabled="valuation.isLocked == true"
          >
            <i class="fa fa-cloud-upload" aria-hidden="true"></i>
          </button>

          <button
            class="btn btn-icon btn-border"
            style="margin-right: 5px"
            @click="navigateTo('valuation-history')"
            title="Valuation History"
          >
            <i class="fa fa-history" aria-hidden="true"></i>
          </button>
        </div>
      </div>

      <div class="row">
        <div
          class="col-md-6"
          v-for="(item, index) in valuation.photo"
          :key="index"
        >
          <div class="row">
            <div class="col-md-12">
              <div
                class="image-container"
                style="
                  width: 100%;
                  height: 300px;
                  border: 2px solid #000;
                  overflow: hidden;
                  text-align: center;
                  display: flex;
                "
              >
                <img
                  :src="rootUrl + 'serve-file?link=' + item.photo_url"
                  class="img-fluid"
                  :alt="item.associated_with"
                  style="max-height: 300px; object-fit: contain; margin: 0 auto"
                />
              </div>

              <!-- style="max-height: 300px; width: 100%; object-fit: fill;" -->
            </div>
          </div>
          <div class="row" style="margin-top: 10px">
            <div class="col-md-6">
              <label>{{ item.caption }}</label>
            </div>
            <div class="col-md-6">
              <button
                class="btn btn-sm-icon pull-right"
                @click="deletePhoto(item.id)"
                title="Delete Photo"
                :disabled="valuation.isLocked == true"
              >
                <i class="fa fa-trash" aria-hidden="true"></i>
              </button>
              <button
                class="btn btn-sm-icon pull-right"
                @click="editPhoto(item)"
                title="Edit Photo"
                :disabled="valuation.isLocked == true"
              >
                <i class="fa fa-pencil pull-right" aria-hidden="true"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        class="row"
        v-if="
          typeof valuation.photo === 'undefined' ||
          valuation.photo == null ||
          valuation.photo.length == 0
        "
      >
        <div class="col-md-12">
          <p class="text-center">No photos uploaded!</p>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="pull-right">
            <button
              type="button"
              class="btn btn-primary"
              :disabled="
                valuation.isLocked == true || valuation.status == 'cancel'
              "
              @click="updatePhotos('valuation-drafts')"
            >
              Continue
            </button>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      id="add-photos-modal"
      size="lg"
      title="Add Photo"
      hide-footer
      ref="addPhotosModal"
      hide-header-close
      no-close-on-esc
      no-close-on-backdrop
    >
      <form @submit.prevent="onSubmit">
        <div class="row">
          <div class="col-md-12">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <div style="display: none">
                    <label class="form-label">Photo</label>
                    <div class="input-group">
                      <input
                        type="file"
                        id="files"
                        class="form-control-file"
                        ref="files"
                        v-on:change="handleFiles()"
                        accept=".png, .jpeg, image/png, image/jpeg"
                      />
                      <p>Recommented height: 300px</p>
                    </div>
                  </div>

                  <button
                    type="button"
                    class="btn btn-icon btn-border"
                    title="Add Photos"
                    @click="showAddPhotosGallery"
                    style="margin-right: 5px"
                    :disabled="valuation.isLocked == true"
                  >
                    <i class="fa fa-camera" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
            </div>

            <div class="row" v-if="isError && typeof error !== 'undefined'">
              <div class="col-md-12">
                <div class="alert alert-danger" role="alert">
                  {{ error.message }}
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <ul>
                  <li
                    v-for="(file, key) in files"
                    :key="key"
                    style="list-style: none"
                  >
                    <!-- {{ file.name }} -->
                    <span class="success-container" v-if="file.id > 0"
                      >Success</span
                    >
                    <!-- <span class="remove-container" v-else>
                      <button
                        type="button"
                        class="btn btn-icon btn-sm"
                        v-on:click="removeFile(key, 'add')"
                      >
                        <i class="fa fa-times" aria-hidden="true"></i>
                      </button>
                    </span>-->
                    <br />
                    <img
                      class="preview"
                      style="max-height: 300px"
                      v-bind:ref="'add-preview' + parseInt(key)"
                    />
                  </li>
                </ul>
              </div>
            </div>

            <div class="row" style="margin-top: 10px">
              <div class="col-md-6">
                <div class="form-group">
                  <label class="form-label">Caption</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="caption"
                    required
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label class="form-label">Associated With</label>
                  <v-select
                    :options="photosAssociation"
                    label="photoable_type"
                    taggable
                    required
                    v-model="associated_with"
                  ></v-select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <button type="submit" class="btn btn-primary pull-right">
              Save
            </button>
            <button
              type="button"
              class="btn btn-secondary pull-right"
              style="margin-right: 5px"
              @click="closeAddModal"
            >
              Cancel
            </button>
          </div>
        </div>
      </form>
    </b-modal>

    <b-modal
      id="add-bulk-photos-modal"
      size="lg"
      title="Add Photos"
      hide-footer
      ref="addBulkPhotosModal"
      hide-header-close
      no-close-on-esc
      no-close-on-backdrop
    >
      <form @submit.prevent="onSubmit">
        <div class="row">
          <div class="col-md-12">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <div style="display: none">
                    <label class="form-label">Photo</label>
                    <div class="input-group">
                      <input
                        type="file"
                        id="bulkfiles"
                        class="form-control-file"
                        ref="bulkFiles"
                        multiple
                        v-on:change="handleBulkFiles()"
                        accept=".png, .jpeg, image/png, image/jpeg"
                      />
                      <p>Recommented height: 300px</p>
                    </div>
                  </div>

                  <button
                    type="button"
                    class="btn btn-icon btn-border"
                    title="Add Photos"
                    @click="showBulkAddPhotosModal"
                    style="margin-right: 5px"
                    :disabled="valuation.isLocked == true"
                  >
                    <i class="fa fa-cloud-upload" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
            </div>

            <div class="row" v-if="isError && typeof error !== 'undefined'">
              <div class="col-md-12">
                <div class="alert alert-danger" role="alert">
                  {{ error.message }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <button type="submit" class="btn btn-primary pull-right">
              Save
            </button>
            <button
              type="button"
              class="btn btn-secondary pull-right"
              style="margin-right: 5px"
              @click="closeBulkAddModal"
            >
              Cancel
            </button>
          </div>
        </div>
      </form>
    </b-modal>

    <b-modal
      id="edit-photos-modal"
      size="lg"
      title="Edit Photo"
      hide-footer
      ref="editPhotosModal"
      hide-header-close
      no-close-on-esc
      no-close-on-backdrop
    >
      <form @submit.prevent="onUpdate">
        <div class="row">
          <div class="col-md-12">
            <div class="row">
              <div class="col-md-12">
                <button
                  type="button"
                  class="btn btn-sm-icon pull-left"
                  title="Rotate Photo"
                  @click.prevent="rotatePhoto"
                  :disabled="valuation.isLocked == true"
                >
                  <i class="fa fa-repeat pull-right" aria-hidden="true"></i>
                </button>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div
                  class="image-container"
                  style="
                    width: 100%;
                    height: 300px;
                    border: 2px solid #000;
                    overflow: hidden;
                    text-align: center;
                    display: flex;
                  "
                >
                  <!-- 90, 180, 270, 360 -->
                  <img
                    :src="rootUrl + 'serve-file?link=' + photo.photo_url"
                    class="img-fluid"
                    :style="{
                      maxHeight: '300px',
                      objectFit: 'contain',
                      margin: '0 auto',
                      transform: 'rotate(-' + rotate + 'deg)',
                    }"
                    alt="Responsive image"
                    ref="preview"
                  />
                </div>
              </div>
            </div>
            <div class="row" style="margin-top: 10px">
              <div class="col-md-6">
                <div class="form-group">
                  <label class="form-label">Caption</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="photo.caption"
                    required
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label class="form-label">Associated With</label>
                  <v-select
                    :options="photosAssociation"
                    label="photoable_type"
                    taggable
                    required
                    v-model="photo.photoable_type"
                  ></v-select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <button type="submit" class="btn btn-primary pull-right">
              Save
            </button>
            <button
              type="button"
              class="btn btn-secondary pull-right"
              style="margin-right: 5px"
              @click="closeEditModal"
            >
              Cancel
            </button>
          </div>
        </div>
      </form>
    </b-modal>
  </div>
</template>

<script>
/* eslint-disable */
import Wizard from "../components/Wizard";
import ValuationHeader from "../components/ValuationHeader";
import Swal from "sweetalert2";
import vSelect from "vue-select";
import { valuationMixin } from "../mixins/valuationMixin";
import { commonMixin } from "../mixins/commonMixin";
export default {
  mixins: [valuationMixin, commonMixin],
  components: {
    "rv-wizard": Wizard,
    "v-select": vSelect,
    ValuationHeader,
  },
  data() {
    return {
      rotate: 0,
      upload: false,
      files: [],
      uploads: [],
      note: "",
      valuation: {},
      error: {},
      isError: false,
      caption: "",
      associated_with: "",
      photo: {},
      edit: false,
      rooms: [],
      isSaved: false,
      interval: null,
    };
  },
  beforeRouteLeave(to, from, next) {
    if (!this.isSaved && to.name != "login") {
      this.updatePhotos("valuation-drafts", next);
    } else {
      next();
    }
  },
  computed: {
    photosAssociation() {
      if (
        typeof this.valuation.photo !== "undefined" &&
        this.valuation.photo != null
      ) {
        return _.map(
          this.valuation.photo,
          _.partialRight(_.pick, ["photoable_type"])
        );
      } else {
        return [];
      }
    },
  },
  methods: {
    rotatePhoto() {
      if (this.rotate < 360) {
        this.rotate = this.rotate + 90;
      } else {
        if (this.rotate == 360) {
          this.rotate = 90;
        } else {
          this.rotate = 0;
        }
      }
    },
    closeAddModal() {
      this.$refs.addPhotosModal.hide();
      this.reset();
    },
    closeBulkAddModal() {
      this.$refs.addBulkPhotosModal.hide();
      this.reset();
    },
    showAddPhotosGallery() {
      setTimeout(() => {
        const el = this.$refs.files;
        el.click();
      }, 10);
    },
    closeEditModal() {
      this.$refs.editPhotosModal.hide();
      this.reset();
      this.loadData(this.$route.params.id);
    },
    showBulkAddPhotosModal() {
      this.$refs.addBulkPhotosModal.show();
      setTimeout(() => {
        const el = this.$refs.bulkFiles;
        el.click();
      }, 10);
    },
    showAddPhotosModal() {
      this.$refs.addPhotosModal.show();
      setTimeout(() => {
        const el = this.$refs.files;
        el.click();
      }, 10);
    },
    updatePhotos(page, next = null) {
      this.isSaved = true;
      this.$http.post(this.rootUrl + "valuation/summary", this.valuation).then(
        (res) => {
          this.refreshToken(res);
          if (next != null) {
            next();
          } else {
            this.$snotify.success("Valuation updated", "Valuation", {
              timeout: 4000,
              showProgressBar: false,
              position: "rightTop",
            });
          }
        },
        (err) => {
          this.errorToast(err.response.data.message);
        }
      );
    },

    handleFiles() {
      const uploadedFiles = this.$refs.files.files;
      if (
        typeof uploadedFiles[0] !== "undefined" &&
        typeof uploadedFiles[0].name !== "undefined"
      ) {
        let filename = uploadedFiles[0].name.substring(
          0,
          uploadedFiles[0].name.lastIndexOf(".")
        );
        this.caption = filename;
      }

      this.files = [];

      for (let i = 0; i < uploadedFiles.length; i++) {
        this.files.push(uploadedFiles[i]);

        if (typeof uploadedFiles[i] !== "undefined") {
          let reg = /(.*?)\.(jpg|jpeg|png|JPG|PNG|JPEG)$/;
          if (!uploadedFiles[i].name.match(reg)) {
            this.error.message = "Invalid file type!";
            this.isError = true;
            this.caption = "";
            return;
          } else {
            this.isError = false;
          }
        }
      }

      this.getImagePreviews("add");
    },

    handleBulkFiles() {
      const uploadedFiles = this.$refs.bulkFiles.files;

      this.files = [];

      for (let i = 0; i < uploadedFiles.length; i++) {
        let filename = uploadedFiles[i].name.substring(
          0,
          uploadedFiles[i].name.lastIndexOf(".")
        );
        this.files.push(uploadedFiles[i]);

        if (typeof uploadedFiles[i] !== "undefined") {
          let reg = /(.*?)\.(jpg|jpeg|png|JPG|PNG|JPEG)$/;
          if (!uploadedFiles[i].name.match(reg)) {
            this.error.message = "Invalid file type!";
            this.isError = true;
            this.caption = "";
            return;
          } else {
            this.isError = false;
          }
        }

        const fileSize = this.files[i].size / 1024 / 1024;
        if (fileSize >= 25) {
          this.isError = true;
          this.error.size = fileSize.toFixed(2);
          this.error.name = this.files[i].name;
          this.error.type = this.files[i].type;
          this.error.message =
            "The file " +
            this.error.name +
            "  (Type: " +
            this.error.type +
            ", Size: " +
            this.error.size +
            "MB) exceeds size limit of 25MB!";
          return;
        }

        // upload
        this.$refs.addBulkPhotosModal.hide();
        this.$parent.$refs.progressModal.show();

        const formData = new FormData();
        formData.append("file", this.files[i]);
        formData.append("caption", filename);
        formData.append("associated_with", "Default");

        formData.append("valuation_id", this.valuation.id);
        formData.append("current_user_role", sessionStorage.getItem("role"));
        this.$http
          .post(this.rootUrl + "valuation-photos", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then(
            (res) => {
              this.refreshToken(res);
              if (typeof res.data != "undefined" && res.data.isError == true) {
                this.errorToast(res.data.message);
                this.$parent.$refs.progressModal.hide();
              } else {
                this.reset();
                this.valuation.photo = res.data;
                this.$parent.$refs.progressModal.hide();
              }
            },
            (err) => {
              this.errorToast(err.response.data.message);

              this.$parent.$refs.progressModal.hide();
              this.$refs.addBulkPhotosModal.show();
            }
          );
      }
    },

    getImagePreviews(str) {
      for (let i = 0; i < this.files.length; i++) {
        if (/\.(jpe?g|png|gif)$/i.test(this.files[i].name)) {
          const reader = new FileReader();
          reader.addEventListener(
            "load",
            function () {
              this.$refs[str + "-preview" + parseInt(i, 10)][0].src =
                reader.result;
            }.bind(this),
            false
          );
          reader.readAsDataURL(this.files[i]);
        } else {
          this.$nextTick(function () {
            this.$refs[str + "-preview" + parseInt(i, 10)][0].src =
              "/img/generic.png";
          });
        }
      }
    },
    removeFile(key, str) {
      this.files.splice(key, 1);
      this.isError = false;
      this.getImagePreviews(str);
    },
    getRooms() {
      // this.$http
      //   .post(this.rootUrl + "valuation/all-rooms", {
      //     id: this.valuation.id,
      //     isHDB: this.valuation.isHDB
      //   })
      //   .then(
      //     res => {
      //       this.refreshToken(res);
      //       this.rooms = res.data;
      //     },
      //     err => {
      //       this.errorToast(err.response.data.message);
      //     }
      //   );
    },
    editPhoto(item) {
      this.edit = true;
      this.photo = item;
      this.$refs.editPhotosModal.show();
    },
    deletePhoto(id) {
      Swal({
        title: "Are you sure to delete?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "Cancel",
      }).then((result) => {
        if (result.value) {
          this.$http
            .post(this.rootUrl + "delete-photo", {
              id: id,
              current_user_role: sessionStorage.getItem("role"),
              valuation_id: this.valuation.id,
            })
            .then(
              (res) => {
                this.refreshToken(res);
                if (
                  typeof res.data != "undefined" &&
                  res.data.isError == true
                ) {
                  this.errorToast(res.data.message);
                }
                this.loadData(this.valuation.id);
              },
              (err) => {
                this.errorToast(err.response.data.message);
              }
            );
        }
      });
    },

    navigateTo(page) {
      this.$router.push({
        name: page,
        params: {
          id: this.$route.params.id,
        },
      });
    },
    loadData(id) {
      this.$parent.$refs.progressModal.show();
      this.$http.get(this.rootUrl + "valuation/" + id, this.corsConfig).then(
        (res) => {
          this.$parent.$refs.progressModal.hide();
          this.refreshToken(res);
          this.valuation = res.data;
          this.getRooms();
        },
        (err) => {
          this.$parent.$refs.progressModal.hide();
          this.errorToast(err.response.data.message);
        }
      );
    },
    onSubmit() {
      if (this.valuation.status == "cancel") {
        if (next != null) {
          next();
        }
        return true;
      }
      if (this.associated_with == null || this.associated_with == "") {
        this.errorToast("Associated with field required");
        return;
      }

      for (let i = 0; i < this.files.length; i++) {
        if (typeof this.files[i] !== "undefined") {
          this.$refs.addPhotosModal.hide();
          this.$parent.$refs.progressModal.show();
          const fileSize = this.files[i].size / 1024 / 1024;
          if (fileSize >= 25) {
            this.isError = true;
            this.error.size = fileSize.toFixed(2);
            this.error.name = this.files[i].name;
            this.error.type = this.files[i].type;
            this.error.message =
              "The file " +
              this.error.name +
              "  (Type: " +
              this.error.type +
              ", Size: " +
              this.error.size +
              "MB) exceeds size limit of 25MB!";
            return;
          }
          const formData = new FormData();
          formData.append("file", this.files[i]);
          formData.append("caption", this.caption);

          if (
            typeof this.associated_with.photoable_type !== "undefined" &&
            this.associated_with.photoable_type != null
          ) {
            formData.append(
              "associated_with",
              this.associated_with.photoable_type
            );
          } else if (
            typeof this.associated_with.accommodation_type !== "undefined" &&
            this.associated_with.accommodation_type != null
          ) {
            formData.append(
              "associated_with",
              this.associated_with.accommodation_type
            );
          } else {
            formData.append("associated_with", this.associated_with);
          }

          formData.append("valuation_id", this.valuation.id);
          formData.append("valuationable_type", "Photos");
          formData.append("current_user_role", sessionStorage.getItem("role"));
          this.$http
            .post(this.rootUrl + "valuation-photos", formData, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            })
            .then(
              (res) => {
                this.refreshToken(res);
                if (
                  typeof res.data != "undefined" &&
                  res.data.isError == true
                ) {
                  this.errorToast(res.data.message);
                  this.$parent.$refs.progressModal.hide();
                } else {
                  this.reset();
                  this.valuation.photo = res.data;
                  this.$parent.$refs.progressModal.hide();
                }
              },
              (err) => {
                this.$parent.$refs.progressModal.hide();
                this.$refs.addPhotosModal.show();
                this.errorToast(err.response.data.message);
              }
            );
        } else {
          this.errorToast("Select an image to upload");
        }
      }
    },

    reset() {
      this.rotate = 0;
      this.caption = "";
      this.associated_with = "";
      this.files = [];
      this.isError = false;
      const input = this.$refs.files;
      if (typeof input !== "undefined") {
        input.type = "text";
        input.type = "file";
      }
    },
    onUpdate() {
      if (
        this.photo.photoable_type == null ||
        this.photo.photoable_type == ""
      ) {
        this.errorToast("Associated with field required");
        return;
      }
      let accommodationType;

      if (
        typeof this.photo.photoable_type.photoable_type !== "undefined" &&
        this.photo.photoable_type.photoable_type != null
      ) {
        accommodationType = this.photo.photoable_type.photoable_type;
      } else if (
        typeof this.photo.photoable_type.accommodation_type !== "undefined" &&
        this.photo.photoable_type.accommodation_type != null
      ) {
        accommodationType = this.photo.photoable_type.accommodation_type;
      } else {
        accommodationType = this.photo.photoable_type;
      }

      this.$refs.editPhotosModal.hide();
      this.$parent.$refs.progressModal.show();
      let formData = {
        id: this.photo.id,
        caption: this.photo.caption,
        associated_with: accommodationType,
        rotate: this.rotate,
        valuation_id: this.valuation.id,
        valuationable_type: "Photos",
        current_user_role: sessionStorage.getItem("role"),
      };

      this.$http.post(this.rootUrl + "valuation-photos", formData, {}).then(
        (res) => {
          this.refreshToken(res);
          if (typeof res.data != "undefined" && res.data.isError == true) {
            this.errorToast(res.data.message);
            this.$parent.$refs.progressModal.hide();
          } else {
            this.reset();
            this.valuation.photo = res.data;
            this.loadData(this.$route.params.id);
            this.$parent.$refs.progressModal.hide();
          }
        },
        (err) => {
          this.$parent.$refs.progressModal.hide();
          this.$refs.editPhotosModal.show();
          this.errorToast(err.response.data.message);
        }
      );
    },
  },
  ready() {
    setInterval(() => {
      this.updatePhotos(null);
    }, 600000);
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  mounted() {
    if (typeof this.$route.params.id !== "undefined") {
      this.loadData(this.$route.params.id);
    } else {
      this.$router.push({ name: "valuations" });
    }
  },
};
</script>
